import { render, staticRenderFns } from "./VipExperience.vue?vue&type=template&id=67455d8d&scoped=true"
import script from "./VipExperience.vue?vue&type=script&lang=js"
export * from "./VipExperience.vue?vue&type=script&lang=js"
import style0 from "./VipExperience.vue?vue&type=style&index=0&id=67455d8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67455d8d",
  null
  
)

export default component.exports